
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","stroke":"#D6DBEA","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}},[_c('path',{attrs:{"d":"M56.5 49.972L53.52 45.5V35c0-4-7.6-8.278-10.5-10.5M46.88 37.588l-7.296-5.848a2.606 2.606 0 10-3.686 3.686l7.066 7.974v5c0 2.362 3.376 6.09 3.376 6.09"}}),_c('path',{attrs:{"d":"M37.02 54.5H14.268a2.75 2.75 0 01-2.748-2.75v-39.5a2.75 2.75 0 012.748-2.75h26c1.52 0 2.75 1.23 2.752 2.75v22.244"}}),_c('path',{attrs:{"d":"M27.532 14.04a.468.468 0 00-.546.126.46.46 0 00-.028.557 6.162 6.162 0 01.28 6.294 4.006 4.006 0 01-1.412-1.766.466.466 0 00-.646-.27 5.439 5.439 0 00-3.275 5.066C21.964 27.351 24.675 30 28 30c3.325 0 6.037-2.649 6.095-5.953a11.141 11.141 0 00-6.563-10.007zM31.02 36.5h-12a1.5 1.5 0 00-1.5 1.5v9a1.5 1.5 0 001.5 1.5h18M17.52 42.5h16.5M26.52 36.5v12"}})])])
          )
        }
      }
    